<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M3.41,2C3.41,2,5,2,5,2C5.55,2,6,1.55,6,1C6,0.45,5.55,0,5,0C5,0,1,0,1,0C0.45,0,0,0.45,0,1C0,1,0,5,0,5C0,5.55,0.45,6,1,6C1.55,6,2,5.55,2,5C2,5,2,3.41,2,3.41C2,3.41,5.29,6.7,5.29,6.7C5.47,6.89,5.72,7,6,7C6.55,7,7,6.55,7,6C7,5.72,6.89,5.47,6.71,5.29C6.71,5.29,3.41,2,3.41,2C3.41,2,3.41,2,3.41,2ZM6,9C5.72,9,5.47,9.11,5.29,9.29C5.29,9.29,2,12.59,2,12.59C2,12.59,2,11,2,11C2,10.45,1.55,10,1,10C0.45,10,0,10.45,0,11C0,11,0,15,0,15C0,15.55,0.45,16,1,16C1,16,5,16,5,16C5.55,16,6,15.55,6,15C6,14.45,5.55,14,5,14C5,14,3.41,14,3.41,14C3.41,14,6.7,10.71,6.7,10.71C6.89,10.53,7,10.28,7,10C7,9.45,6.55,9,6,9C6,9,6,9,6,9ZM15,10C14.45,10,14,10.45,14,11C14,11,14,12.59,14,12.59C14,12.59,10.71,9.3,10.71,9.3C10.53,9.11,10.28,9,10,9C9.45,9,9,9.45,9,10C9,10.28,9.11,10.53,9.29,10.71C9.29,10.71,12.59,14,12.59,14C12.59,14,11,14,11,14C10.45,14,10,14.45,10,15C10,15.55,10.45,16,11,16C11,16,15,16,15,16C15.55,16,16,15.55,16,15C16,15,16,11,16,11C16,10.45,15.55,10,15,10C15,10,15,10,15,10ZM15,0C15,0,11,0,11,0C10.45,0,10,0.45,10,1C10,1.55,10.45,2,11,2C11,2,12.59,2,12.59,2C12.59,2,9.29,5.29,9.29,5.29C9.11,5.47,9,5.72,9,6C9,6.55,9.45,7,10,7C10.28,7,10.53,6.89,10.71,6.71C10.71,6.71,14,3.41,14,3.41C14,3.41,14,5,14,5C14,5.55,14.45,6,15,6C15.55,6,16,5.55,16,5C16,5,16,1,16,1C16,0.45,15.55,0,15,0C15,0,15,0,15,0Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Fullscreen',
} as DefineComponent
</script>
